import { HttpClient, HttpParams                                           } from '@angular/common/http';
import { Injectable                                                       } from '@angular/core';
import { Apollo, gql                                                      } from 'apollo-angular';
import { BehaviorSubject, Observable, Subject                             } from 'rxjs';
import { takeUntil                                                        } from 'rxjs/operators';
import { environment                                                      } from '../../../environments/environment';
import { ObjetoSelectDto, ObjetoUserSelectDto                             } from '../../model/MesaAyudaInterfaces/ObjetoSelectGlobalInterface';
import { CategoriaInterface                                               } from '../../model/MesaAyudaInterfaces/categoriaInterface';
import { DashboardMonitoreoInterface                                      } from '../../model/MesaAyudaInterfaces/dashboardMonitoreoInterface';
import { EncargadoXpersonaInterface, TecnicosDestinoOrigen                } from '../../model/MesaAyudaInterfaces/encargadosXpersonaInterface';
import { IncidenciasInterface                                             } from '../../model/MesaAyudaInterfaces/incidenciasInterface';
import { MunicipioXpersonasInterface, MunicipioXpersonasPerServInterface  } from '../../model/MesaAyudaInterfaces/municipioXpersonasInterface';
import { MunicipiosInterface                                              } from '../../model/MesaAyudaInterfaces/municipiosInterface';
import { NivelesServicioInterface                                         } from '../../model/MesaAyudaInterfaces/nivelesServicioInterface';
import { PersonaServiciosInterface                                        } from '../../model/MesaAyudaInterfaces/personaServiciosInterface';
import { PersonasXincidenciaInterface                                     } from '../../model/MesaAyudaInterfaces/personaXincidenciaInterface';
import { Reply                                                            } from '../../model/MesaAyudaInterfaces/replyInterface';
import { ReporteSabanaOrigen                                              } from '../../model/MesaAyudaInterfaces/reportTotalSabanaInterface';
import { ServicioInterface                                                } from '../../model/MesaAyudaInterfaces/servicioInterface';
import { TotalIncidenciasXestatusInterface                                } from '../../model/MesaAyudaInterfaces/totalIncidenciasXestatusInterface';
import { TotalIncidenciasXpersonaServicioInterface                        } from '../../model/MesaAyudaInterfaces/totalIncidenciasXpersonaServicioInterface';
import { TotalNivelesIncidenciasInterface                                 } from '../../model/MesaAyudaInterfaces/totalNivelesXincidenciaInterface';
import { TicketsPorDiaDTOInterface                                        } from '../../model/MesaAyudaInterfaces/totalServiciosAtendidosInterface';
import { UnidadAdministrativaInterface                                    } from '../../model/MesaAyudaInterfaces/unidadesAdmvaInterface';
import { UsuariosInterface                                                } from '../../model/MesaAyudaInterfaces/usuariosInterface';
import { UsuariosPrioritariosDTO                                          } from '../../model/MesaAyudaInterfaces/usuariosPrioritariosDTO';
import { OrigenCierreIncidencia                                           } from '../../model/MesaAyudaInterfaces/origenCierreIncidencia';
import { CorreoCorrespondencia                                            } from '../../model/MesaAyudaInterfaces/correoCorrespondenciaInterface';
import { ConfiguraMunicipioXtecnico } from '../../model/MesaAyudaInterfaces/configuraMunicipiosXtecnicoInterface';

const _url = environment.api;

@Injectable( { providedIn: 'root' } )
export class MesaAyudaCrudService {
  constructor( private _http: HttpClient, private apollo: Apollo ) { }

  /*** "CATEGORÍAS" ***/
  // public GetCategoriaAll() : Observable<CategoriaInterface[]>{
  //   return this._http.get<CategoriaInterface[]>(`${_url}Categorias/GetAll`);
  // }
  public GetCategoriaById( id:number ) : Observable<CategoriaInterface>{
    return this._http.get<CategoriaInterface>(`${_url}Categorias/GetCategoriaById/${id}`);
  }
  public CreateCategoria( categoria:CategoriaInterface, usuarioId:number ) : Observable<CategoriaInterface>{
    return this._http.post<CategoriaInterface>(`${_url}Categorias/CreateCategoria/${usuarioId}`, categoria);
  }
  public UpdateCategoria( categoria:CategoriaInterface, usuarioId:number ) : Observable<CategoriaInterface>{
    return this._http.put<CategoriaInterface>(`${_url}Categorias/UpdateCategoria/${usuarioId}`, categoria);
  }
  public FindCategorias( categoria?:string, estatus:string = "0,1" ) : Observable<CategoriaInterface[]>{
    let parametros = new HttpParams();
    if( categoria ){ parametros = parametros.append( "categoria", categoria.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<CategoriaInterface[]>(`${_url}Categorias/Find`, { params : parametros });
  }
  /*** FIN DE "CATEGOÍAS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "ENCARGADO POR PERSONA" ***/
  public GetEncargadoXpersonaAll() : Observable<EncargadoXpersonaInterface[]> {
    return this._http.get<EncargadoXpersonaInterface[]>(`${_url}EncargadoXpersona/GetAll`);
  }
  public CreateEncargadoXpersona( encargado:EncargadoXpersonaInterface, usuarioId:number ) : Observable<EncargadoXpersonaInterface>{
    return this._http.post<EncargadoXpersonaInterface>(`${_url}EncargadoXpersona/CreateEncargadoXpersona/${usuarioId}`, encargado);
  }
  public UpdateEncargadoXpersona( encargado:EncargadoXpersonaInterface, usuarioId:number ) : Observable<EncargadoXpersonaInterface>{
    return this._http.put<EncargadoXpersonaInterface>(`${_url}EncargadoXpersona/UpdateEncargadoXpersona/${usuarioId}`, encargado);
  }
  public FindEncargadoXpersona( encargadoId?:number, personaServicioId?:number, estatus:string = "0,1" ) : Observable<EncargadoXpersonaInterface[]>{
    let parametros = new HttpParams();
    if( encargadoId ){ parametros = parametros.append( "encargadoId", encargadoId.toString() ); }
    if( personaServicioId ){ parametros = parametros.append( "personaServicioId", personaServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<EncargadoXpersonaInterface[]>(`${_url}EncargadoXpersona/Find`, { params : parametros });
  }
  public MunicipiosDelEncargadoPorpersonasServicio(encargadoId:number) : Observable<MunicipiosInterface[]> {
    return this._http.get<MunicipiosInterface[]>(`${_url}EncargadoXpersona/MunicipiosDelEncargadoPorpersonasServicio?encargadoId=${encargadoId}`);
  }
  public TecnicosYcoordinadoresDelEncargado(personaId:number) : Observable<TecnicosDestinoOrigen>{
    return this._http.get<TecnicosDestinoOrigen>(`${_url}EncargadoXpersona/TecnicosYcoordinadoresDelEncargado/${personaId}`);
  }
  public UpdateListEncargadosXpersonas( personaId:number, listPersonasAsignadas?:ObjetoSelectDto[] ) : Observable<ObjetoSelectDto[]> {
    return this._http.put<ObjetoSelectDto[]>(`${_url}EncargadoXpersona/UpdateListEncargadosXpersonas/${personaId}`, listPersonasAsignadas);
  }
  /*** FIN DE"ENCARGADO POR PERSONA" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "ESTATUS" ***/
  public TotalIncidenciasPorEstatus(fechaInicio:string, fechaFin:string) : Observable<TotalIncidenciasXestatusInterface[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<TotalIncidenciasXestatusInterface[]>(`${_url}Estatus/TotalIncidenciasPorEstatus`, { params: parametros });
  }
  /*** FIN DE "ESTATUS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "INSIDENCIAS" ***/
  public DesconectarDependencia() : Observable<boolean> {
    return this._http.get<boolean>(`${_url}Incidencias/DesconectarDependencia`);
  }
  public GetIncidenciasAll() : Observable<IncidenciasInterface[]> {
    return this._http.get<IncidenciasInterface[]>(`${_url}Incidencias/GetAll`);
  }
  public GetIncidenciaById( id:number ) : Observable<IncidenciasInterface> {
    return this._http.get<IncidenciasInterface>(`${_url}Incidencias/GetIncidenciaById/${id}`);
  }
  public CreateIncidencia( incidencia:IncidenciasInterface, municipioId:number, usuarioId:number, tecnicoId?:number ) : Observable<IncidenciasInterface> {
    let parametros : string = '';
    if( tecnicoId ){ parametros = `?tecnicoId=${tecnicoId}`; }
    if( parametros != '' ){
      return this._http.post<IncidenciasInterface>(`${_url}Incidencias/CreateIncidencia/${municipioId}/${usuarioId}${parametros}`, incidencia);
    }else{
      return this._http.post<IncidenciasInterface>(`${_url}Incidencias/CreateIncidencia/${municipioId}/${usuarioId}`, incidencia);
    }
  }
  public UpdateIncidencia( incidencia:IncidenciasInterface, IdUsuario:number, usuarioId?:number, estatusInci?:number ) : Observable<IncidenciasInterface> {
    let parametros : string = '';
    if( usuarioId ){ parametros = `?usuarioId=${usuarioId}`; }
    if( parametros ){ if( estatusInci ){ parametros = parametros + `&estatusInci=${estatusInci}`; }
    }else{ if( estatusInci ){ parametros = `?estatusInci=${estatusInci}`; } }

    if( parametros != '' ){
      return this._http.put<IncidenciasInterface>(`${_url}Incidencias/UpdateIncidencia/${IdUsuario}${parametros}`, incidencia );
    }else{
      return this._http.put<IncidenciasInterface>(`${_url}Incidencias/UpdateIncidencia/${IdUsuario}`, incidencia );
    }
  }
  public FindIncidencia(
    page:number, pageSize:number, servicioId?:number, usuarioId?:number, descripcion?:string, fechaApertura?:string, fechaAsignacion?:string, fechaVisualizacion?:string
    , fechaInicioAtencion?:string, fechaFinCierre?:string, fechaFinValidacion?:string, personaIdTecnico?: number, estatus:string = "0,1,2,3,4,5", dashboard:boolean = false
    , idMunicipio:string = "-1"
  ) : Observable<Reply<IncidenciasInterface[]>>
  {
    let parametros = new HttpParams();
    if( servicioId          ) parametros = parametros.append( "servicioId"          , servicioId          .toString() );
    if( usuarioId           ) parametros = parametros.append( "usuarioId"           , usuarioId           .toString() );
    if( descripcion         ) parametros = parametros.append( "descripcion"         , descripcion         .toString() );
    if( fechaApertura       ) parametros = parametros.append( "fechaApertura"       , fechaApertura       .toString() );
    if( fechaAsignacion     ) parametros = parametros.append( "fechaAsignacion"     , fechaAsignacion     .toString() );
    if( fechaVisualizacion  ) parametros = parametros.append( "fechaVisualizacion"  , fechaVisualizacion  .toString() );
    if( fechaInicioAtencion ) parametros = parametros.append( "fechaInicioAtencion" , fechaInicioAtencion .toString() );
    if( fechaFinCierre      ) parametros = parametros.append( "fechaFinCierre"      , fechaFinCierre      .toString() );
    if( fechaFinValidacion  ) parametros = parametros.append( "fechaFinValidacion"  , fechaFinValidacion  .toString() );
    if( personaIdTecnico    ) parametros = parametros.append( "personaIdTecnico"    , personaIdTecnico    .toString() );
    parametros = parametros.append( "estatus"     , estatus               );
    parametros = parametros.append( "dashboard"   , dashboard .toString() );
    parametros = parametros.append( "idMunicipio" , idMunicipio           );

    return this._http.get<Reply<IncidenciasInterface[]>>(`${_url}Incidencias/Find/${page}/${pageSize}`, { params : parametros });
  }
  // int page, string? FechaDesde, string? fechaHasta
  public DashboardMonitoreo(page:number, fechaDesde?:string, fechaHasta?:string) : Observable<Reply<DashboardMonitoreoInterface>> {
    let parametros = new HttpParams();
    if( fechaDesde ){ parametros = parametros.append( "fechaDesde", fechaDesde.toString() ); }
    if( fechaHasta ){ parametros = parametros.append( "fechaHasta", fechaHasta.toString() ); }

    return this._http.get<Reply<DashboardMonitoreoInterface>>(`${_url}Incidencias/DashboardMonitoreo/${page}`, { params : parametros });
  }
  public FindIncidenciasXPersona( page:number, personaId:number, pageSize:number, estatus:string = "0,1,2,3,4,5" ) : Observable<Reply<IncidenciasInterface[]>> {
    let parametros = new HttpParams();
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<Reply<IncidenciasInterface[]>>(`${_url}Incidencias/FindIncidenciasXPersona/${personaId}/${page}/${pageSize}`, { params : parametros });
  }
  public FindIncidenciasDelEncargadoPorPersonasServicio(
    page:number, encargadoId:number, pageSize:number, servicioId?:number, usuarioId?:number, personaIdTecnico?:number, estatus:string = "0,1,2,3,4,5"
  ) : Observable<Reply<IncidenciasInterface[]>>{
    let parametros = new HttpParams();
    if( servicioId ){ parametros = parametros.append( "servicioId", servicioId.toString() ); }
    if( usuarioId ){ parametros = parametros.append( "usuarioId", usuarioId.toString() ); }
    if( personaIdTecnico ){ parametros = parametros.append( "personaIdTecnico", personaIdTecnico.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<Reply<IncidenciasInterface[]>>(`${_url}Incidencias/FindIncidenciasDelEncargadoPorPersonasServicio/${encargadoId}/${page}/${pageSize}`, { params : parametros });
  }
  public ReaperturaIncidencia( incidencia:IncidenciasInterface, IdUsuario:number) : Observable<IncidenciasInterface> {
    return this._http.put<IncidenciasInterface>(`${_url}Incidencias/ReaperturaIncidencia/${IdUsuario}`, incidencia );
  }

  public CierreIncidencia(incidencia: IncidenciasInterface): Observable<string> {
    return this._http.get<string>(`${_url}Incidencias/close/${incidencia.incidenciaId}?token=admin`);
  }


  public IncidenciasPorEstatusDashboard( estatus:string = "0,1,2,3,4,5" ) : Observable<IncidenciasInterface[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<IncidenciasInterface[]>(`${_url}Incidencias/IncidenciasPorEstatusDashboard`, { params : parametros });
  }
  public IncidenciaPuedeVerCoordinador( incidenciaId:number, personaId:number ) : Observable<IncidenciasInterface[]> {
    return this._http.get<IncidenciasInterface[]>(`${_url}Incidencias/IncidenciaPuedeVerCoordinador/${incidenciaId}/${personaId}`);
  }
  /*** FIN "INSIDENCIAS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "MUNICIPIOS" ***/
  public GetMunicipiosAll() : Observable<MunicipiosInterface[]>{
    return this._http.get<MunicipiosInterface[]>(`${_url}Municipios/GetAll`);
  }
  public GetMunicipiosById( id:number ) : Observable<MunicipiosInterface>{
    return this._http.get<MunicipiosInterface>(`${_url}MunicipioXpersonas/GetMunicipioXpersonaById/${id}`);
  }
  /*** FIN DE "MUNICIPIOS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "MUNICIPIO POR PERSONA" ***/
  public GetMunicipioXpersonasAll() : Observable<MunicipioXpersonasInterface[]>{
    return this._http.get<MunicipioXpersonasInterface[]>(`${_url}MunicipioXpersonas/GetAll`);
  }
  public GetMunicipioXpersonaPerServByMuniXpersId( muniXpersId:number ) : Observable<MunicipioXpersonasPerServInterface> {
    return this._http.get<MunicipioXpersonasPerServInterface>(`${_url}MunicipioXpersonas/GetMunicipioXpersonaPerServByMuniXpersId/${muniXpersId}`);
  }
  public CreateMunicipioXpersona( persona:MunicipioXpersonasInterface, usuarioId:number ) : Observable<MunicipioXpersonasInterface>{
    return this._http.post<MunicipioXpersonasInterface>(`${_url}MunicipioXpersonas/CreateMunicipioXpersona/${usuarioId}`, persona);
  }
  public UpdateMunicipioXPersona( persona:MunicipioXpersonasInterface, usuarioId:number ) : Observable<MunicipioXpersonasInterface>{
    return this._http.put<MunicipioXpersonasInterface>(`${_url}MunicipioXpersonas/UpdateMunicipioXpersona/${usuarioId}`, persona);
  }
  public FindMunicipioXpersonas( municipioId?:number, personaServicioId?:number, estatus:string = "0,1" ) : Observable<MunicipioXpersonasInterface[]> {
    let parametros = new HttpParams();
    if( municipioId ){ parametros = parametros.append( "municipioId", municipioId.toString() ); }
    if( personaServicioId ){ parametros = parametros.append( "personaServicioId", personaServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<MunicipioXpersonasInterface[]>(`${_url}MunicipioXpersonas/Find`, { params : parametros });
  }
  public MunicipiosXtecnicoDisponibles( personaId:number ) : Observable<ObjetoSelectDto[]>{
    return this._http.get<ObjetoSelectDto[]>(`${_url}MunicipioXpersonas/MunicipiosXtecnicoDisponibles/${personaId}`);
  }
  public GetConfiguracionMunicipiosXTecnico( personaId:number ) : Observable<Reply<ConfiguraMunicipioXtecnico>>{
    return this._http.get<Reply<ConfiguraMunicipioXtecnico>>(`${_url}MunicipioXpersonas/GetConfiguracionMunicipiosXTecnico/${personaId}`);
  }
  public ConfigurarZonaDelTecnico( persona:ConfiguraMunicipioXtecnico, usuarioId:number ) : Observable<Reply<any>>{
    return this._http.post<Reply<any>>(`${_url}MunicipioXpersonas/ConfigurarZonaDelTecnico/${usuarioId}`, persona);
  }
  /*** FIN DE "MUNICIPIO POR PERSONA" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "NIVELES SERVICIO" ***/
  public GetNivelesServicioAll() : Observable<NivelesServicioInterface[]>{
    return this._http.get<NivelesServicioInterface[]>(`${_url}NivelesServicio/GetAll`);
  }
  public GetNivelesServicioById( id:number ) : Observable<NivelesServicioInterface>{
    return this._http.get<NivelesServicioInterface>(`${_url}NivelesServicio/GetNivelesServicioById/${id}`);
  }
  public CreateNivelServicio( nivel:NivelesServicioInterface, usuarioId:number ) : Observable<NivelesServicioInterface>{
    return this._http.post<NivelesServicioInterface>(`${_url}NivelesServicio/CreateNivelServicio/${usuarioId}`, nivel);
  }
  public UpdateNivelServicio( nivel:NivelesServicioInterface, usuarioId:number ) : Observable<NivelesServicioInterface>{
    return this._http.put<NivelesServicioInterface>(`${_url}NivelesServicio/UpdateNivelServicio/${usuarioId}`, nivel);
  }
  public FindNivelesServicio( nivelServicio?:number, estatus:string = "0,1" ) : Observable<NivelesServicioInterface[]>{
    let parametros = new HttpParams();
    if( nivelServicio ){ parametros = parametros.append( "NivelServicio", nivelServicio.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<NivelesServicioInterface[]>(`${_url}NivelesServicio/Find`, { params : parametros });
  }
  public NivelesServicioPorIncidencia( fechaInicio:string, fechaFin:string ) : Observable<TotalNivelesIncidenciasInterface[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<TotalNivelesIncidenciasInterface[]>(`${_url}NivelesServicio/NivelesServicioPorIncidencia`, { params : parametros });
  }

  public OrigenCierreIncidencias( fechaInicio:string, fechaFin:string ) : Observable<OrigenCierreIncidencia[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<OrigenCierreIncidencia[]>(`${_url}Incidencias/OrigenCierreIncidencias`, { params : parametros });
  }

  /*** FIN DE "NIVELES SERVICIO" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "PERSONA SERVICIOS" ***/
  public GetPersonaServiciosAll() : Observable<PersonaServiciosInterface[]>{
    return this._http.get<PersonaServiciosInterface[]>(`${_url}PersonaServicios/GetAll`);
  }
  public GetPersonaServicioById( id:number ) : Observable<PersonaServiciosInterface>{
    return this._http.get<PersonaServiciosInterface>(`${_url}PersonaServicios/GetPersonaServicioById/${id}`);
  }
  public CreatePersonaServicio( persona:PersonaServiciosInterface, usuarioId:number ) : Observable<PersonaServiciosInterface>{
    return this._http.post<PersonaServiciosInterface>(`${_url}PersonaServicios/CreatePersonaServicio/${usuarioId}`, persona);
  }
  public UpdatePersonaServicios( persona:PersonaServiciosInterface, usuarioId:number ) : Observable<PersonaServiciosInterface>{
    return this._http.put<PersonaServiciosInterface>(`${_url}PersonaServicios/UpdatePersonaServicio/${usuarioId}`, persona);
  }
  public FindPersonaServicios( personaId?:number, municipioAdscritoId?:number, rol?:string, estatus:string = "0,1"  ) : Observable<PersonaServiciosInterface[]>{
    let parametros = new HttpParams();
    if( personaId ){ parametros = parametros.append( "personaId", personaId.toString() ); }
    if( municipioAdscritoId ){ parametros = parametros.append( "municipioAdscritoId", municipioAdscritoId.toString() ); }
    if( rol ){ parametros = parametros.append( "rol", rol ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<PersonaServiciosInterface[]>(`${_url}PersonaServicios/Find`, { params : parametros });
  }
  public FindPersonasServiciosLibres() : Observable<PersonaServiciosInterface[]>{
    return this._http.get<PersonaServiciosInterface[]>(`${_url}PersonaServicios/FindPersonasServiciosLibres`);
  }
  public IncidenciasPorPersonaServicio( fechaInicio:string, fechaFin:string ) : Observable<TotalIncidenciasXpersonaServicioInterface[]> {
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<TotalIncidenciasXpersonaServicioInterface[]>(`${_url}PersonaServicios/IncidenciasPorPersonaServicio`, { params : parametros });
  }
  public FindPersonasServiciosCoordinadorSelect() : Observable<ObjetoUserSelectDto[]>{
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindPersonasServiciosCoordinadorSelect`);
  }
  public UsuariosDelAdmininSinPersonasServicios( flagSinEvaluarPs?:boolean ) : Observable<ObjetoUserSelectDto[]>{
    let parametros = new HttpParams();
    if (flagSinEvaluarPs) parametros = parametros.append( "flagSinEvaluarPs", flagSinEvaluarPs.toString() );

    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/UsuariosDelAdmininSinPersonasServicios`, { params : parametros });
  }
  public FindPersonasServiciosDelCoordinadorSelect( personaId?:number, usuarioId?:number ) : Observable<ObjetoUserSelectDto[]>{
    let parametros = new HttpParams();
    if( personaId ){ parametros = parametros.append( "personaId", personaId.toString() ); }
    if( usuarioId ){ parametros = parametros.append( "usuarioId", usuarioId.toString() ); }
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindPersonasServiciosDelCoordinadorSelect`, { params : parametros });
  }
  public FindUsuariosPorCoordinadorYadmonSelect( personaId?:number, nombreBusqueda?:string ) : Observable<ObjetoUserSelectDto[]>{
    let parametros = new HttpParams();
    if( personaId       ){ parametros = parametros.append( "personaId"      , personaId.toString()  ); }
    if( nombreBusqueda  ){ parametros = parametros.append( "nombreBusqueda" , nombreBusqueda        ); }

    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindUsuariosPorCoordinadorYadmonSelect`, { params : parametros });
  }
  public FindPersonasServicioTecnicosActivosSelect() : Observable<ObjetoUserSelectDto[]> {
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindPersonasServicioTecnicosActivosSelect`);
  }
  public FindTecnicosXmunicipioActivosSelect( incidenciaId:number, personaId?:number ) : Observable<ObjetoUserSelectDto[]> {
    let parametros = new HttpParams();
    if( personaId ){ parametros = parametros.append( "personaId", personaId.toString() ); }
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindTecnicosXmunicipioActivosSelect/${incidenciaId}`, { params : parametros });
  }
  public FindTecnicosXusuarioActivosSelect( usuarioId:number ): Observable<ObjetoUserSelectDto[]> {
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/FindTecnicosXusuarioActivosSelect/${usuarioId}`);
  }
  public UsuariosDelCoordSinPersonasServicios( usuarioId:number ): Observable<ObjetoUserSelectDto[]> {
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/UsuariosDelCoordSinPersonasServicios/${usuarioId}`);
  }
  public UsuariosDelTecnico( usuarioId:number ): Observable<ObjetoUserSelectDto[]> {
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonaServicios/UsuariosDelTecnico/${usuarioId}`);
  }
  public UpdateZonaPersonaServicio(usuarioId:number) : Observable<Reply<PersonaServiciosInterface>>{
    return this._http.put<Reply<PersonaServiciosInterface>>(`${_url}PersonaServicios/UpdateZonaPersonaServicio/${usuarioId}`, null);
  }
  /*** FIN DE "PERSONA SERVICIOS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "PERSONA POR INCIDENCIA" ***/
  public GetPersonaXincidenciaAll() : Observable<PersonasXincidenciaInterface[]>{
    return this._http.get<PersonasXincidenciaInterface[]>(`${_url}PersonasXincidencia/GetAll`);
  }
  public CreatePersonasXincidencia( persona:PersonasXincidenciaInterface, usuarioId:number ) : Observable<PersonasXincidenciaInterface>{
    return this._http.post<PersonasXincidenciaInterface>(`${_url}PersonasXincidencia/CreatePersonasXincidencia/${usuarioId}`, persona);
  }
  public UpdatePersonaXincidencia( persona:PersonasXincidenciaInterface, usuarioId:number ) : Observable<PersonasXincidenciaInterface>{
    return this._http.put<PersonasXincidenciaInterface>(`${_url}PersonasXincidencia/UpdatePersonasXincidencia/${usuarioId}`, persona);
  }
  public FindPersonaXincidencia( incidenciaId?:number, personaServicioId?:number, estatus:string = "0,1" ) : Observable<PersonasXincidenciaInterface[]>{
    let parametros = new HttpParams();
    if( incidenciaId ){ parametros = parametros.append( "incidenciaId", incidenciaId.toString() ); }
    if( personaServicioId ){ parametros = parametros.append( "personaServicioId", personaServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<PersonasXincidenciaInterface[]>(`${_url}PersonasXincidencia/Find`, { params : parametros });
  }
  public FindPersonasXincidenciaSelect( incidenciaId:number, personaServicioId?:number, estatus:string = "0,1" ) : Observable<ObjetoUserSelectDto[]>{
    let parametros = new HttpParams();
    if( personaServicioId ){ parametros = parametros.append( "personaServicioId", personaServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}PersonasXincidencia/FindPersonasXincidenciaSelect/${incidenciaId}`, { params : parametros });
  }
  /*** FIN DE "PERSONA POR INCIDENCIA" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "REPORTES" ***/
  public GetReporteSabana(fechaInicio:string, fechaFin:string) : Observable<ReporteSabanaOrigen[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<ReporteSabanaOrigen[]>(`${_url}Reportes/GetReporteSabana`, { params : parametros });
  }
  /*** FIN DE "REPORTES" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "SERVICIOS" ***/
  public GetServicioAll() : Observable<ServicioInterface[]>{
    return this._http.get<ServicioInterface[]>(`${_url}Servicios/GetAll`);
  }
  public GetServicioById( id:number ) : Observable<ServicioInterface>{
    return this._http.get<ServicioInterface>(`${_url}Servicios/GetServiciosById/${id}`);
  }
  public CreateServicio( servicio:ServicioInterface, usuarioId:number ) : Observable<ServicioInterface>{
    return this._http.post<ServicioInterface>(`${_url}Servicios/CreateServicios/${usuarioId}`, servicio);
  }
  public UpdateServicio( servicio:ServicioInterface, usuarioId:number ) : Observable<ServicioInterface>{
    return this._http.put<ServicioInterface>(`${_url}Servicios/UpdateServicios/${usuarioId}`, servicio);
  }
  public FindServicios(
    categoriaId?:number, concepto?:string, descripcion?:string, solucionServicio?:string, canalDeSolicitud?:string, tiempoRespuesta?:number, tiempoSolucion?:number
    , nivelServicioId?:number, estatus:string = "0,1"
  ) : Observable<ServicioInterface[]>{
    let parametros = new HttpParams();
    if( categoriaId ){ parametros = parametros.append( "categoriaId", categoriaId.toString() ); }
    if( concepto ){ parametros = parametros.append( "concepto", concepto ); }
    if( descripcion ){ parametros = parametros.append( "descripcion", descripcion ); }
    if( solucionServicio ){ parametros = parametros.append( "solucionServicio", solucionServicio ) }
    if( canalDeSolicitud ){ parametros = parametros.append( "canalDeSolicitud", canalDeSolicitud ); }
    if( tiempoRespuesta ){ parametros = parametros.append( "tiempoRespuesta", tiempoRespuesta.toString() ); }
    if( tiempoSolucion ){ parametros = parametros.append( "tiempoSolucion", tiempoSolucion.toString() ); }
    if( nivelServicioId ){ parametros = parametros.append( "nivelServicioId", nivelServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<ServicioInterface[]>(`${_url}Servicios/Find`, { params : parametros });
  }
  public ServiciosAtendidos( fechaInicio:string, fechaFin:string ) : Observable<TicketsPorDiaDTOInterface[]>{
    let parametros = new HttpParams();
    parametros = parametros.append( "fechaInicio", fechaInicio );
    parametros = parametros.append( "fechaFin", fechaFin );
    return this._http.get<TicketsPorDiaDTOInterface[]>(`${_url}Servicios/ServiciosAtendidos`, { params : parametros });
  }
  public FindServiciosSelect(
    categoriaId?:number, concepto?:string, descripcion?:string, solucionServicio?:string, canalDeSolicitud?:string, tiempoRespuesta?:number, tiempoSolucion?:number
    , nivelServicioId?:number, estatus:string = "0,1"
  ) : Observable<ObjetoSelectDto[]>{
    let parametros = new HttpParams();
    if( categoriaId ){ parametros = parametros.append( "categoriaId", categoriaId.toString() ); }
    if( concepto ){ parametros = parametros.append( "concepto", concepto ); }
    if( descripcion ){ parametros = parametros.append( "descripcion", descripcion ); }
    if( solucionServicio ){ parametros = parametros.append( "solucionServicio", solucionServicio ) }
    if( canalDeSolicitud ){ parametros = parametros.append( "canalDeSolicitud", canalDeSolicitud ); }
    if( tiempoRespuesta ){ parametros = parametros.append( "tiempoRespuesta", tiempoRespuesta.toString() ); }
    if( tiempoSolucion ){ parametros = parametros.append( "tiempoSolucion", tiempoSolucion.toString() ); }
    if( nivelServicioId ){ parametros = parametros.append( "nivelServicioId", nivelServicioId.toString() ); }
    parametros = parametros.append( "estatus", estatus );
    return this._http.get<ObjetoSelectDto[]>(`${_url}Servicios/FindServiciosSelect`, { params : parametros });
  }
  /*** FIN DE "SERVICIOS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** "USUARIOS" ***/
  GET_USER_GRAPH_BY_ID = gql`
    query($idEmpleado: Int)
    {
      ctlUsuarios ( where: { numeroEmpleado: { eq: $idEmpleado } } )
      {
        numeroEmpleado
        nombreEmpleado
        correo
        idMunicipio
        ctlUnidadesAdministrativas { nombre }
      }
    }
  `;
  GET_USER_GRAPH_ALL = gql`
    query
    {
      ctlUsuarios
      {
        numeroEmpleado
        nombreEmpleado
        correo
        idMunicipio
        ctlUnidadesAdministrativas { nombre }
      }
    }
  `;
  GET_AREA_ADMVA_BY_USER = gql`
    query($idUnidadAdministrativa: Int){
      ctlUnidadesAdministrativas( where: { idUnidadAdministrativa: { eq: $idUnidadAdministrativa } } )
      { siglas, nombre }
    }
  `;
  public GetUsuariosAll() : Observable<UsuariosInterface[]>{
    return this._http.get<UsuariosInterface[]>(`${_url}Usuarios/GetAll`);
  }
  public GetUsuarioById( id:number ) : Observable<UsuariosInterface> {
    return this._http.get<UsuariosInterface>(`${_url}Usuarios/GetUserById/${id}`);
  }

  public GetUserGraphApiById( id:number ) : Observable<UsuariosInterface>
  {
    return this._http.get<UsuariosInterface>(`${_url}Usuarios/GetUserGraphById/${id}`);
  }

  public usuarios : BehaviorSubject<UsuariosInterface[]> = new BehaviorSubject<UsuariosInterface[]>([]);
  public usuario : BehaviorSubject<UsuariosInterface> = new BehaviorSubject<UsuariosInterface>({});
  public behUnidadAdva : BehaviorSubject<UnidadAdministrativaInterface> = new BehaviorSubject<UnidadAdministrativaInterface>({});
  RespUsuarios : UsuariosInterface[] = [];
  RespUsuario : UsuariosInterface = {};
  UnidadAdministrativa : UnidadAdministrativaInterface = {};

  public GetUserGraphAll() : Observable<UsuariosInterface[]>{
    this.RespUsuarios = new Array();
    this.usuarios = new BehaviorSubject<UsuariosInterface[]>([]);
    this.apollo.watchQuery( { query: this.GET_USER_GRAPH_ALL } ).valueChanges.subscribe((result: any) => {
      result?.data['ctlUsuarios'].forEach(
        (usuario : any) =>
        {
          this.RespUsuarios.push({
            idUsuario:usuario.numeroEmpleado,
            usuario:usuario.nombreEmpleado,
            email:usuario.correo,
            area:usuario['ctlUnidadesAdministrativas'].nombre,
            ciudad:usuario.idMunicipio
          });
        }
      );
      this.usuarios.next(this.RespUsuarios);
      // this.GetUsuariosAll().subscribe(resp => { this.usuarios.next(resp); });
    });
    return this.usuarios.asObservable();
  }

  public GetUserGraphById(id:number) : Observable<UsuariosInterface>{
    this.usuario = new BehaviorSubject<UsuariosInterface>({});
    this.apollo.watchQuery( { query: this.GET_USER_GRAPH_ALL } ).valueChanges.subscribe((result: any) => {
      let Flag = false;
      result?.data['ctlUsuarios'].forEach(
        (usuario : any) =>
        {
          if(usuario.numeroEmpleado == id){
            this.RespUsuario = {
              idUsuario:usuario.numeroEmpleado,
              usuario:usuario.nombreEmpleado,
              email:usuario.correo,
              area:usuario['ctlUnidadesAdministrativas'].nombre,
              ciudad:usuario.idMunicipio
            }
            this.usuario.next(this.RespUsuario);
            Flag = true;
          }
        }
      );
      // if(Flag == false){ this.GetUsuarioById(id).subscribe(resp => { this.usuario.next(resp); }); }
    });
    return this.usuario.asObservable();
  }

  public GetAreaAdmva(id: number): Observable<UnidadAdministrativaInterface> {
    const destroy$ = new Subject<void>();
    this.behUnidadAdva = new BehaviorSubject<UnidadAdministrativaInterface>({}); // Asegúrate de que esto sea un objeto válido según tu interfaz

    this.apollo.watchQuery({ query: this.GET_AREA_ADMVA_BY_USER, variables: { idUnidadAdministrativa: id } })
      .valueChanges
      .pipe(takeUntil(destroy$)) // Asegúrate de limpiar la suscripción
      .subscribe({
        next: (result: any) => {
          result?.data['ctlUnidadesAdministrativas'].forEach(
            (unidad : any) =>
            {
              this.UnidadAdministrativa = { sigla: unidad.sigla, nombre: unidad.nombre };
              this.behUnidadAdva.next(this.UnidadAdministrativa);
            }
          );
        },
        error: (err) => {
          console.error('Error fetching area administrativa:', err);
          // Manejo de error, puedes emitir un error o manejarlo como prefieras
        }
      });

    return this.behUnidadAdva.asObservable();
  }
  /*** FIN DE "USUARIOS" ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/
  /*** ############################################################################################################# ***/


  public GetUsuarioPrioritarios() : Observable<UsuariosPrioritariosDTO[]>{
    return this._http.get<UsuariosPrioritariosDTO[]>(`${_url}UsuariosPrioritarios/GetAll`);
  }

  public UpdateUsuarioPrioritario(UsuariosPrioritariosDTO: UsuariosPrioritariosDTO) : Observable<UsuariosPrioritariosDTO[]>{
    return this._http.put<UsuariosPrioritariosDTO[]>(`${_url}UsuariosPrioritarios/UpdateUsuarioPrioritario`, UsuariosPrioritariosDTO);
  }

  public CreateUsuarioPrioritario(UsuariosPrioritariosDTO: UsuariosPrioritariosDTO) : Observable<UsuariosPrioritariosDTO[]>{
    return this._http.post<UsuariosPrioritariosDTO[]>(`${_url}UsuariosPrioritarios`, UsuariosPrioritariosDTO);
  }
  public GetUsuariosNoPrioritarios() : Observable<ObjetoUserSelectDto[]>{
    return this._http.get<ObjetoUserSelectDto[]>(`${_url}UsuariosPrioritarios/UsuariosNoPrioritarios`);
  }
  public GetTicketsPorSemana() : Observable<TicketsPorDiaDTOInterface[]>{
    return this._http.get<TicketsPorDiaDTOInterface[]>(`${_url}Incidencias/DashboardMonitoreo/TicketsPorSemana`);
  }

  public CorreoCorrespondencia( numeroEmpleado:number ) : Observable<CorreoCorrespondencia>{
    return this._http.get<CorreoCorrespondencia>(`${_url}Incidencias/CorreoCorrespondencia/${numeroEmpleado}`);
  }

  public CrearCorreoCorrespondencia(correoCorrespondencia: CorreoCorrespondencia) : Observable<CorreoCorrespondencia> {
    return this._http.post<CorreoCorrespondencia>(`${_url}Incidencias/CrearCorreoCorrespondencia`, correoCorrespondencia);
  }
}
